var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10.5 17H9.5C9.224 17 9 16.776 9 16.5V15.5C9 15.224 9.224 15 9.5 15H10.5C10.776 15 11 15.224 11 15.5V16.5C11 16.776 10.776 17 10.5 17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.867 7.966 12.095 7.308 11.963 6.607C11.828 5.89 11.275 5.28 10.574 5.081C9.468 4.767 8.437 5.4 8.108 6.353C7.98 6.724 7.668 7 7.275 7H6.984C6.403 7 5.997 6.436 6.159 5.878C6.588 4.406 7.84 3.285 9.384 3.047C10.908 2.812 12.353 3.596 13.257 4.846C14.437 6.478 14.089 8.231 13.07 9.25Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3c00cd38eb7678f8d7999c21fecedcca.svg";
export { ForwardRef as ReactComponent };